import { useState } from "react";

import { makeGetApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import { BannerNotificationType } from "../../../components/SimpleNotification";

export function ClassDetailsViewModel(logout, id) {
  const [classe, setClasse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });

  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [allergenOptions, setAllergenOptions] = useState([]);
  const [specSheetTestOptions, setSpecSheetTestOptions] = useState([]);

  const getClass = async function () {
    setLoading(true);

    let callResult = await makeGetApiCall(`classes/${id}`);
    if (callResult.success) {
      setClasse(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setLoading(false);
  };

  const updateClass = async function (values) {
    let callResult = await makePutApiCall(`classes/id`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Class updated",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getSpecSheetTestsForDropdown = async function () {
    let callResult = await makeGetApiCall("specSheetTestsForDropdown");
    if (callResult.success) {
      setSpecSheetTestOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getAllergens = async function () {
    let callResult = await makeGetApiCall("allergensForDropdown");
    if (callResult.success) {
      setAllergenOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    getClass,
    loading,
    classe,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    getSpecSheetTestsForDropdown,
    getAllergens,
    updateClass,
    allergenOptions,
    specSheetTestOptions,
    setClasse,
  };
}
